import {ESprintenTeam} from '@repo/shared/Customer/Coop/SprintenTeams/SprintenTeams.types'
import {atomWithReset} from 'jotai/utils'

type SinglePlayerDataState = {
  clicks: number
  time: number
  team: ESprintenTeam
  player: string
}

export const singlePlayerDataState = atomWithReset<SinglePlayerDataState | null>(null)
